import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/hooks/useAuth";
import Login from "./pages/Login";
import ProjectsList from "./pages/ProjectsList";
import ProjectView from "./pages/ProjectView";
import StepDetail from "./pages/StepDetail";
import BillOfMaterials from "./pages/BillOfMaterials";
import RunCreate from "./pages/RunCreate";
import RunDetail from "./pages/RunDetail";
import SupplierSelection from "./pages/SupplierSelection";
import NotFound from "./pages/NotFound";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const queryClient = new QueryClient();

const AppRoutes = () => {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><ProjectsList /></ProtectedRoute>} />
      <Route path="/project/:projectId" element={<ProtectedRoute><ProjectView /></ProtectedRoute>} />
      <Route path="/project/:projectId/step/:stepId" element={<ProtectedRoute><StepDetail /></ProtectedRoute>} />
      <Route path="/project/:projectId/bom" element={<ProtectedRoute><BillOfMaterials /></ProtectedRoute>} />
      <Route path="/project/:projectId/run/new" element={<ProtectedRoute><RunCreate /></ProtectedRoute>} />
      <Route path="/project/:projectId/run/:runId" element={<ProtectedRoute><RunDetail /></ProtectedRoute>} />
      <Route path="/project/:projectId/run/:runId/suppliers" element={<ProtectedRoute><SupplierSelection /></ProtectedRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
